import { pb } from "./pocketbase";

/** Scope every protected query to the current authenticated identity. */
export function authCacheScope(): string {
  const id = pb.authStore.record?.id;
  return typeof id === "string" && id ? `user:${id}` : "anonymous";
}

// Presentation preferences use the stable principal above. Protected runtime
// buffers also need a session/access fence, without treating token rotation as
// an identity change.
let dataEpoch=0;
const dataPrincipal=()=>JSON.stringify([authCacheScope(),pb.authStore.record?.access_revision ?? 0]);
let lastDataPrincipal=dataPrincipal();
const dataListeners=new Set<()=>void>();
pb.authStore.onChange(()=>{
  const next=dataPrincipal();
  if(next!==lastDataPrincipal){lastDataPrincipal=next;dataEpoch++;dataListeners.forEach(listener=>listener());}
});
export const authDataIdentity=()=>`${dataEpoch}:${lastDataPrincipal}`;
export function subscribeAuthDataIdentity(listener:()=>void){dataListeners.add(listener);return ()=>{dataListeners.delete(listener);};}
